export default __webpack_public_path__ + "static/media/user.5073381f.svg";